import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=0f9a4a16&scoped=true&"
import script from "@/views/Users/Reseller/CreateDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Reseller/CreateDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Reseller/create-dialog.scss?vue&type=style&index=0&id=0f9a4a16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a4a16",
  null
  
)

export default component.exports